/**
 * @voltxampere/ui — ESP32-WROOM-32 module variant (Sprint 43-5, placeholder)
 *
 * PLACEHOLDER. Full GPIO + ADC + PWM + I2C + SPI + WiFi/BT simulation
 * arrives Sprint 46+ (Xtensa LX6 dual-core family).
 *
 * Reference: Espressif ESP32-WROOM-32, module package. Xtensa LX6 dual-
 * core 32-bit. Vcc 3.0-3.6 V, fmax 240 MHz, 4 MB Flash / 520 KB SRAM,
 * 26 usable GPIO, 18 ADC1+ADC2 channels (12-bit), 16 PWM channels,
 * WiFi 802.11 b/g/n + Bluetooth 4.2 LE.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuEsp32Wroom32 = {
    id: "esp32-wroom-32",
    nameTr: "ESP32-WROOM-32 (Modül, placeholder)",
    nameEn: "ESP32-WROOM-32 (Module, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "ESP32-WROOM-32",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 3.3,
        vLow: 0,
        threshold: 1.65,
        propagationDelay: 8e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-esp32-wroom32.js.map